import React from 'react';
import Page from '../components/Page';
import Footer from '../components/Footer';
import headerImage from './TitlePage_HeaderImage.jpg';
import { css } from '@emotion/css';
import { corporateRed } from '../assets/colors';
import { Localized } from '../components/Localized';

/**
 * @brief Renders the first page of the report
 * @param {String} props.assessmentName The name of the assessment that is displayed on the cover sheet
 */
const TitlePage = (props) => {
    return (
        <Page fixedPageHeight>
            <div
                className={css({
                    display: 'flex',
                    minHeight: '100%',
                    flexFlow: 'column',
                })}
            >
                <img
                    className={css({
                        width: '100%',
                        backgroundColor: 'white',
                    })}
                    src={headerImage}
                    alt="Titelbild"
                />
                <div
                    className={css({
                        backgroundColor: 'white',
                        fontFamily: 'Proxima Nova',
                        fontSize: '10pt',
                        fontWeight: 700,
                        textTransform: 'uppercase',
                        textAlign: 'left',
                        color: corporateRed,
                        paddingTop: '6mm',
                    })}
                >
                    <Localized de="Persönlicher Report" en="Personal report" />
                </div>
                <div
                    className={css({
                        backgroundColor: 'white',
                        fontFamily: 'Proxima Nova',
                        fontSize: '24pt',
                        fontWeight: 800,
                        textTransform: 'uppercase',
                        textAlign: 'left',
                        color: 'black',
                        paddingTop: '8mm',
                        flexGrow: 1,
                    })}
                >
                    <Localized {...props.assessmentName} />
                </div>
                <Footer />
            </div>
        </Page>
    );
};

export default TitlePage;
